module.exports = __webpack_public_path__ + "static/DS_birthday_adult-7a46f56926ccaa5e7cda57cafee30504.jpg";